import { render } from "./InputRecaptcha.vue?vue&type=template&id=324b4f66"
import script from "./InputRecaptcha.vue?vue&type=script&lang=js"
export * from "./InputRecaptcha.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__